export interface MilestonePlanWizardRow {
  id?: string;
  milestoneNumber?: number;
  description: string;
  amount: string;
  rotAmount?: string;
  percent: string;
  endDate: string;
}

interface ReconcileMilestonePlanRowsOptions {
  previousRows: MilestonePlanWizardRow[];
  count: number;
  startNumber: number;
  defaultDescription: string;
  distributionChanged: boolean;
}

/**
 * Keeps existing rows and entered amounts when more milestones are added.
 * A smaller count must never silently remove work. The wizard validates the
 * requested count and the amount sum before allowing the user to save.
 */
export const reconcileMilestonePlanRows = ({
  previousRows,
  count,
  startNumber,
  defaultDescription,
  distributionChanged
}: ReconcileMilestonePlanRowsOptions): MilestonePlanWizardRow[] => {
  if (!distributionChanged && previousRows.length === count) return previousRows;

  let nextNumber = Math.max(startNumber, ...previousRows.map(row => (row.milestoneNumber ?? 0) + 1));
  return Array.from({ length: Math.max(count, previousRows.length) }, (_, index) => {
    const previous = previousRows[index];
    if (previous) return previous;
    const milestoneNumber = nextNumber++;
    return {
      milestoneNumber,
      description: `${defaultDescription} #${milestoneNumber}`,
      amount: '',
      percent: '',
      endDate: ''
    };
  });
};
